import { render, staticRenderFns } from "./DesignLibraryDependencyWarning.vue?vue&type=template&id=c4e86a76&"
import script from "./DesignLibraryDependencyWarning.vue?vue&type=script&lang=ts&"
export * from "./DesignLibraryDependencyWarning.vue?vue&type=script&lang=ts&"
import style0 from "./DesignLibraryDependencyWarning.vue?vue&type=style&index=0&id=c4e86a76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports